import { render, staticRenderFns } from "./CCShortStringEditor.vue?vue&type=template&id=820961da&scoped=true&"
import script from "./CCShortStringEditor.vue?vue&type=script&lang=ts&"
export * from "./CCShortStringEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CCShortStringEditor.vue?vue&type=style&index=0&id=820961da&scoped=true&lang=css&"
import style1 from "./CCShortStringEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820961da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFadeTransition,VIcon,VTextField})
